import type { SituationStatus } from "@/@types/unlock-request";

export const ACCESS_REQUEST_TAB_PARAM: string = "tab";

export const ACCESS_REQUEST_TAB = {
  ACCESS: "acessos",
  UNLOCK: "desbloqueios",
} as const;

export type AccessRequestTab =
  (typeof ACCESS_REQUEST_TAB)[keyof typeof ACCESS_REQUEST_TAB];

export const ACCESS_REQUEST_TABS: readonly AccessRequestTab[] =
  Object.values(ACCESS_REQUEST_TAB);

export const ACCESS_REQUEST_BASE_PATH = {
  FINANCE: "/financeiro/requisicao-de-acesso",
  STORE_BACK_OFFICE: "/retaguarda-de-loja/requisicao-de-acesso",
} as const;

export const unlockTabPath = (basePath: string): string =>
  `${basePath}?${ACCESS_REQUEST_TAB_PARAM}=${ACCESS_REQUEST_TAB.UNLOCK}`;

export const accessRequestDetailPath = (
  basePath: string,
  id: string,
): string => `${basePath}/${id}/editar`;

export const SITUATION_STATUS = {
  FOUND: "FOUND",
  NOT_FOUND: "NOT_FOUND",
  UNAVAILABLE: "UNAVAILABLE",
  INVALID_CPF: "INVALID_CPF",
} as const satisfies Readonly<Record<SituationStatus, SituationStatus>>;

export const UNLOCK_COMMENT_MAX_LENGTH: number = 255;

export const ACCESS_REQUEST_SLA_HOURS: number = 48;

export const MILLISECONDS_PER_HOUR: number = 1000 * 60 * 60;

export const ACCESS_TAB_LOAD_ERROR_STATUS: number = 500;
